<template>
    <div>
        <div ref="OilMakerQRScanDetailed" style="min-height: 500px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
                chart2 : null,
                pieSeries : null,
                pieSeries2 : null,
                line1 : null,
                line2 : null,

                selectedSlice : null,


                dummyData : [{
                    "company": "IDEMITSU",
                    "count": 286,
                    "sub_data": [{ variant: "MPX1", count: 247 }, { variant: "MPX2", count: 63 }, { variant: "MPX3", count: 154 }, { variant: "SPX1", count: 275 }, { variant: "SPX2", count: 286 }]
                }, {
                    "company": "TCS",
                    "count": 234,
                    "sub_data": [{ variant: "MPX1", count: 114 }, { variant: "MPX2", count: 223 }, { variant: "MPX3", count: 102 }, { variant: "SPX1", count: 196 }, { variant: "SPX2", count: 70 }]
                }, {
                    "company": "FEDERAL",
                    "count": 234,
                    "sub_data": [{ variant: "MPX1", count: 71 }, { variant: "MPX2", count: 7 }, { variant: "MPX3", count: 91 }, { variant: "SPX1", count: 103 }, { variant: "SPX2", count: 153 }]
                }, {
                    "company": "STC",
                    "count": 345,
                    "sub_data": [{ variant: "MPX1", count: 276 }, { variant: "MPX2", count: 82 }, { variant: "MPX3", count: 171 }, { variant: "SPX1", count: 113 }, { variant: "SPX2", count: 140 }]
                }, {
                    "company": "NIPPON",
                    "count": 316,
                    "sub_data": [{ variant: "MPX1", count: 295 }, { variant: "MPX2", count: 14 }, { variant: "MPX3", count: 163 }, { variant: "SPX1", count: 90 }, { variant: "SPX2", count: 255 }]
                }],
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            },
        },
        methods : {
            getData () {
                let length = this.chart.data.length;

                // this.chart.addData(this.dummyData, length);
                this.chart.addData(this.data && this.data.length > 0 ? this.data : [{company:"No Data", count:"1", sub_data:[{ variant:"No Data", count:1 }]}], length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                let container = am4core.create(this.$refs.OilMakerQRScanDetailed, am4core.Container);
                container.width = am4core.percent(100);
                container.height = am4core.percent(100);
                container.layout = "horizontal";


                this.chart = container.createChild(am4charts.PieChart);

                // Add and configure Series
                this.pieSeries = this.chart.series.push(new am4charts.PieSeries());
                this.pieSeries.dataFields.value = "count";
                this.pieSeries.dataFields.category = "company";
                this.pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;
                this.pieSeries.dx = -50
                //this.pieSeries.labels.template.text = "{category}\n{value.percent.formatNumber('#.#')}%";

                this.pieSeries.colors.list = [
                    am4core.color("#2c1ec9"),
                    am4core.color("#ff4554"),
                    am4core.color("#2effd2"),
                    am4core.color("#68ff54"),
                    am4core.color("#a459ff"),
                    am4core.color("#ffb657"),
                ]

                this.pieSeries.slices.template.events.on("hit", (event) => {
                    this.selectSlice(event.target.dataItem);
                })

                this.chart2 = container.createChild(am4charts.PieChart);
                this.chart2.width = am4core.percent(30);
                this.chart2.radius = am4core.percent(80);

                // Add and configure Series
                this.pieSeries2 = this.chart2.series.push(new am4charts.PieSeries());
                this.pieSeries2.dataFields.value = "count";
                this.pieSeries2.dataFields.category = "variant";
                this.pieSeries2.slices.template.states.getKey("active").properties.shiftRadius = 0;
                //this.pieSeries2.labels.template.radius = am4core.percent(50);
                //this.pieSeries2.labels.template.inside = true;
                //this.pieSeries2.labels.template.fill = am4core.color("#ffffff");
                // this.pieSeries2.labels.template.disabled = true;
                // this.pieSeries2.ticks.template.disabled = true;
                this.pieSeries2.alignLabels = false;
                this.pieSeries2.events.on("positionchanged", this.updateLines);
                this.pieSeries2.dx = -100

                this.pieSeries2.labels.template.adapter.add("radius", (radius, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 3)) {
                        return am4core.percent(2.5);
                    }
                    return radius;
                });

                this.pieSeries2.labels.template.adapter.add("fill", (color, target) => {
                    console.log('%cLabelMakerQRScanDetailed.vue line:119 target.dataItem', 'color: #007acc;', target.dataItem);
                    if (target.dataItem && (target.dataItem.values.value.percent > 3)) {
                        return am4core.color("#000");
                    }
                    return am4core.color("#fff");
                });

                let interfaceColors = new am4core.InterfaceColorSet();

                this.line1 = container.createChild(am4core.Line);
                this.line1.strokeDasharray = "2,2";
                this.line1.strokeOpacity = 0.5;
                this.line1.stroke = interfaceColors.getFor("alternativeBackground");
                this.line1.isMeasured = false;

                this.line2 = container.createChild(am4core.Line);
                this.line2.strokeDasharray = "2,2";
                this.line2.strokeOpacity = 0.5;
                this.line2.stroke = interfaceColors.getFor("alternativeBackground");
                this.line2.isMeasured = false;

                this.chart.events.on("datavalidated", () => {
                    setTimeout(() => {
                        this.selectSlice(this.pieSeries.dataItems.getIndex(0));
                    }, 1000);
                });

                // Add legend
                this.chart.legend = new am4charts.Legend();
            },
            selectSlice(dataItem) {
                this.selectedSlice = dataItem.slice;

                // let fill = this.selectedSlice.fill;

                // let count = dataItem.dataContext.sub_data.length;
                // this.pieSeries2.colors.list = [];
                // for (var i = 0; i < count; i++) {
                //     this.pieSeries2.colors.list.push(fill.brighten(i * 2 / count));
                // }
                
                this.pieSeries2.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1"),
                    am4core.color("#B1DFDB"),
                    am4core.color("#C3DFB1"),
                    am4core.color("#CDB1DF"),
                    am4core.color("#DFD4B1"),
                ]

                this.chart2.data = dataItem.dataContext.sub_data;
                this.pieSeries2.appear();

                let middleAngle = this.selectedSlice.middleAngle;
                let firstAngle = this.pieSeries.slices.getIndex(0).startAngle;
                let animation = this.pieSeries.animate([{ property: "startAngle", to: firstAngle - middleAngle }, { property: "endAngle", to: firstAngle - middleAngle + 360 }], 600, am4core.ease.sinOut);
                animation.events.on("animationprogress", this.updateLines);

                this.selectedSlice.events.on("transformed", this.updateLines);

                //  var animation = chart2.animate({property:"dx", from:-container.pixelWidth / 2, to:0}, 2000, am4core.ease.elasticOut)
                //  animation.events.on("animationprogress", this.updateLines)
            },
            updateLines() {
                if (this.selectedSlice) {
                    let p11 = { x: this.selectedSlice.radius * am4core.math.cos(this.selectedSlice.startAngle), y: this.selectedSlice.radius * am4core.math.sin(this.selectedSlice.startAngle) };
                    let p12 = { x: this.selectedSlice.radius * am4core.math.cos(this.selectedSlice.startAngle + this.selectedSlice.arc), y: this.selectedSlice.radius * am4core.math.sin(this.selectedSlice.startAngle + this.selectedSlice.arc) };

                    p11 = am4core.utils.spritePointToSvg(p11, this.selectedSlice);
                    p12 = am4core.utils.spritePointToSvg(p12, this.selectedSlice);

                    let p21 = { x: 0, y: -this.pieSeries2.pixelRadius };
                    let p22 = { x: 0, y: this.pieSeries2.pixelRadius };

                    p21 = am4core.utils.spritePointToSvg(p21, this.pieSeries2);
                    p22 = am4core.utils.spritePointToSvg(p22, this.pieSeries2);

                    this.line1.x1 = p11.x;
                    this.line1.x2 = p21.x;
                    this.line1.y1 = p11.y;
                    this.line1.y2 = p21.y;

                    this.line2.x1 = p12.x;
                    this.line2.x2 = p22.x;
                    this.line2.y1 = p12.y;
                    this.line2.y2 = p22.y;
                }
            }
        }
    }
</script>

<style scoped>

</style>